<button pButton type="button" icon="pi pi-bell" class="p-button-text p-button-rounded bell-btn" (click)="op.toggle($event)" pTooltip="Notificaciones">
  <ng-container *ngIf="(unread$ | async) as count">
    <p-badge *ngIf="count > 0" [value]="count > 99 ? '99+' : (count + '')" severity="danger" styleClass="bell-badge"></p-badge>
  </ng-container>
</button>

<p-overlayPanel #op (onShow)="onPanelShow()" [style]="{ width: '360px' }">
  <div class="notif-head">
    <span>Notificaciones</span>
    <button pButton type="button" label="Marcar todas" class="p-button-text p-button-sm" (click)="markAll()"></button>
  </div>
  <div class="notif-list">
    <div class="notif-item" *ngFor="let n of (list$ | async)" [class.unread]="!n.read" (click)="open(n)">
      <i class="pi" [ngClass]="n.read ? 'pi-circle' : 'pi-circle-fill'"></i>
      <div class="notif-body">
        <strong>{{ n.title }}</strong>
        <p>{{ n.body }}</p>
        <span class="event-time">{{ n.createdAt | timeElapsed }}</span>
      </div>
    </div>
    <div class="empty-state" *ngIf="(list$ | async)?.length === 0">
      <p>Sin notificaciones.</p>
    </div>
  </div>
</p-overlayPanel>
